// Notez que toutes les clés sont maintenant en français,
// mais pour la continuité sur Matomo nous gardons les valeurs anglaises
export enum EventCategories {
  DEFAUT = "defaultCategory",
  GENERAL = "General",
  PARCOURS = "Parcours",
  ACCOMPAGNEMENT = "Accompaniment",
  MONTANT_ATTENDU = "Montant attendu",
}
